import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { LocationComponent } from './locations.component';
var ɵ0 = { title: 'CORE.SERVICES.NAVIGATION.LOCATIONS.TITLE' };
var routes = [
    {
        path: 'localizacoes',
        component: LocationComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0
    }
];
var LocationsModule = /** @class */ (function () {
    function LocationsModule() {
    }
    return LocationsModule;
}());
export { LocationsModule };
export { ɵ0 };
